/**
 * Golden Elia — Legal content (Greek + English).
 *
 * Placeholders marked [ΣΥΜΠΛΗΡΩΣΕ] need to be replaced by the merchant
 * before going live with real customers.
 */

export const BUSINESS_INFO = {
  legal_name: "[ΣΥΜΠΛΗΡΩΣΕ ΕΠΩΝΥΜΙΑ]", // π.χ. "Αστροπαλίτης Γεώργιος Ατομική Επιχείρηση"
  trade_name: "Golden Elia",
  address: "[ΣΥΜΠΛΗΡΩΣΕ ΔΙΕΥΘΥΝΣΗ ΕΔΡΑΣ]", // π.χ. "Λεωφ. Κνωσσού 123, 71306 Ηράκλειο Κρήτης"
  city: "[ΣΥΜΠΛΗΡΩΣΕ ΠΟΛΗ]",
  postal_code: "[ΣΥΜΠΛΗΡΩΣΕ Τ.Κ.]",
  country: "Greece / Ελλάδα",
  afm: "[ΣΥΜΠΛΗΡΩΣΕ ΑΦΜ]",
  doy: "[ΣΥΜΠΛΗΡΩΣΕ ΔΟΥ]",
  gemi: "[ΣΥΜΠΛΗΡΩΣΕ ΓΕΜΗ]",
  phone: "+30 698 414 1945",
  email: "admin@goldenelia.gr",
  whatsapp: "+306984141945",
  instagram: "https://www.instagram.com/goldenelia_2026/",
};

export const LAST_UPDATED = "12 Φεβρουαρίου 2026";
